// prettier-ignore
export enum DEVICE_SIZE {
  WIDESCREEN = `wide`,
  DESKTOP    = `desktop`,
  TABLET     = `tablet`,
  MOBILE     = `mobile`,
}

// prettier-ignore
export const mediaConfig = {
	mediaFormats: {
		[DEVICE_SIZE.WIDESCREEN] : { width: 1200 },
		[DEVICE_SIZE.DESKTOP]    : { width: 992 },
		[DEVICE_SIZE.TABLET]     : { width: 768 },
		[DEVICE_SIZE.MOBILE]     : { width: 576 },
	},
};
